// @generated by protoc-gen-connect-query v2.3.1 with parameter "target=ts"
// @generated from file travplaces/v1/city.proto (package travplaces.v1, syntax proto3)
/* eslint-disable */

import { CityService } from "./city_pb";

/**
 * ListCities returns every city, alphabetical.
 *
 * @generated from rpc travplaces.v1.CityService.ListCities
 */
export const listCities = CityService.method.listCities;

/**
 * GetCity returns one city by id.
 *
 * @generated from rpc travplaces.v1.CityService.GetCity
 */
export const getCity = CityService.method.getCity;

/**
 * CreateCity adds a city (bbox + centre required).
 *
 * @generated from rpc travplaces.v1.CityService.CreateCity
 */
export const createCity = CityService.method.createCity;

/**
 * DeleteCity removes a city and its POIs (cascade).
 *
 * @generated from rpc travplaces.v1.CityService.DeleteCity
 */
export const deleteCity = CityService.method.deleteCity;
